/* eslint-disable no-restricted-imports */
import type { BeforeRequestHook } from 'ky';

import { useAuthStore } from '~/store/auth.store';

/**
 * Ky beforeRequest hook — attaches Authorization: Bearer header
 * from the in-memory access token stored in auth.store.
 */
export const bearerInterceptor: BeforeRequestHook = (request) => {
  const { accessToken } = useAuthStore.getState();
  if (accessToken) {
    request.headers.set('Authorization', `Bearer ${accessToken}`);
  }
};
